module.exports = __webpack_public_path__ + "static/media/house_martell.0473968e.png";